import component from './view';

export default component;